import { Box } from '@chakra-ui/react';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { MdDragHandle } from 'react-icons/md';

export const DragHandle = (props: any) => {
  return (
    <div {...props} >
      <MdDragHandle color='gray' size={24} style={{ cursor: props.isDragging ? 'grabbing' : 'grab' }} />
    </div>
  );
};